import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const archiveItems = document.querySelectorAll('.archive__item');
if (archiveItems.length > 0) {
    gsap.set('.archive__item', {
        autoAlpha: 0,
    });

    const rows = document.querySelectorAll('.rows-reveal');
    if (rows.length > 0) {
        rows.forEach(row => {
            const items = row.querySelectorAll('.archive__item');
            if (items.length > 0) {
                gsap.to(items, {
                    autoAlpha: 1,
                    duration: 0.0,
                    delay: 0.1,
                    stagger: {
                        each: 0.1,
                        from: "random",
                    },
                    scrollTrigger: {
                        trigger: row,
                        start: 'top 80%',
                        toggleActions: 'play none none none',
                        once: true,
                    }
                });
            }
        });
    }
}